// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__Lp2H4","message":"Loading_message__LrNkw"};